import { IDLE_TIMEOUT_MINUTES } from "@alm/domain";
import { optionalOneOf, optionalString } from "@/lib/search";
import { LOGIN_AUDIENCES, type LoginAudience } from "./-login-audience";

interface LoginSearch {
  next?: string;
  reason?: string;
  email?: string;
  /** Minutes the idle sign-out waited, so the page can say how long. */
  after?: number;
  /** The phone app's sign-in, which ends any session it finds before showing the form. */
  fresh?: boolean;
  /** Who a link says is coming, which only adds a line of help. */
  as?: LoginAudience;
}

/** A minutes count the idle guard could have sent; anything else is dropped. */
function idleMinutes(value: unknown): number | undefined {
  const minutes = Number(value);
  return Number.isInteger(minutes) &&
    minutes >= IDLE_TIMEOUT_MINUTES.min &&
    minutes <= IDLE_TIMEOUT_MINUTES.max
    ? minutes
    : undefined;
}

export const loginSearch = (search: Record<string, unknown>): LoginSearch => ({
  next: optionalString(search.next),
  reason: optionalString(search.reason),
  // Handed over by a building's careers site, which cannot sign the applicant in itself.
  email: optionalString(search.email),
  after: idleMinutes(search.after),
  as: optionalOneOf(LOGIN_AUDIENCES, search.as),
  fresh: search.fresh === "1" || search.fresh === 1 || search.fresh === true ? true : undefined,
});

/** Only same-origin paths are honoured, so a mailed link cannot steer anyone off-site. */
export function safeNext(next: string | undefined): string {
  if (!next || !next.startsWith("/") || next.startsWith("//") || next.startsWith("/login"))
    return "/";
  return next;
}
